<div class="individual-dtc-vch">
  <!-- DTCコンポーネント -->
  <div class="mb-3">
    <individual-diag-code
      ref="dtcComponent"
      :limitedHeightMode="true"
      @diagApiStatusChange="handleDiagApiStatusChange"
    />
  </div>

  <!-- 制御作動履歴コンポーネント -->
  <div v-if="showVch">
    <individual-vehicle-control-history
      ref="vchComponent"
      :limitedHeightMode="true"
      :diagApiStatus="diagApiStatus"
    />
  </div>
</div>
